import VueSocket from '@/lib/vue3-socket-io';
import {useGlobalSocketStore} from '@/stores/globalSocketStore';

export const initSocket = async app => {
  // Tạm fake vuex và sửa thư viện do ko muốn viết lại code
  const store = useGlobalSocketStore();
  app.use(new VueSocket({vuex: {store}}));
};
